import PropTypes from "prop-types";
import GuidedSearchSingle from "../../../../../../../../../features/browse-search/components/GuidedSearchSingle";
import BaseSearchPage from "../../../SearchPage";

export const SearchPage = ({ formatTranslation, location }) => (
  <BaseSearchPage
    formatTranslation={formatTranslation}
    location={location}
    topContent={<GuidedSearchSingle />}
  />
);

SearchPage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  location: PropTypes.object,
};

export default SearchPage;
